import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FactoryProfileComponent } from './factory-profile/factory-profile.component';
import { EventsComponent } from './events/events.component';
import { SponsoringComponent } from './sponsoring/sponsoring.component';
import { UsersComponent } from './users/users.component';
import { ProductsComponent } from './products/products.component';
import { CertificatesComponent } from './certificates/certificates.component';
import { ManufacturerRoutingModule } from './manufacturer-routing.module';
import { MaterialsModule } from '../materials/materials.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ChangeImageComponent } from '../shared/change-image/change-image.component';
import { BuySponsorComponent } from './sponsoring/buy-sponsor/buy-sponsor.component';
import { SendSponsoringEmailComponent } from './sponsoring/send-sponsoring-email/send-sponsoring-email.component';
//import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { AddEditUserComponent } from './users/add-edit-user/add-edit-user.component';
import { AddEditEventComponent } from './events/add-edit-event/add-edit-event.component';
import { EventDetailsComponent } from './events/event-details/event-details.component';
import { BillingComponent } from './sponsoring/billing/billing.component';
import { CardBillingComponent } from './sponsoring/billing/card-billing/card-billing.component';
import { AddEditCertificateComponent } from './certificates/add-edit-certificate/add-edit-certificate.component';
import { CertificateDetailsComponent } from './certificates/certificate-details/certificate-details.component';
import { AddProductComponent } from './products/add-product/add-product.component';
import { RequestedProductDetailsComponent } from './products/requested-product-details/requested-product-details.component';
import { PlansAndPricingComponent } from './plans-and-pricing/plans-and-pricing.component';
import { PlansBillingComponent } from './plans-billing/plans-billing.component';

import { SendEmailsComponent } from './sponsoring/send-emails/send-emails.component';
import { BaseChartDirective } from 'ng2-charts';
import { EllipsisTooltipDirective } from '../shared/directives/ellipsis-tooltip.directive';


@NgModule({
    declarations: [FactoryProfileComponent,
        EventsComponent,
        SponsoringComponent,
        UsersComponent,
        ProductsComponent,
        CertificatesComponent,
        AddEditEventComponent,
        EventDetailsComponent,
        BuySponsorComponent,
        SendSponsoringEmailComponent,
        AddEditUserComponent,
        BillingComponent,
        CardBillingComponent,
        AddEditCertificateComponent,
        CertificateDetailsComponent,
        AddProductComponent,
        RequestedProductDetailsComponent,
        PlansAndPricingComponent,
        PlansBillingComponent,
        SendEmailsComponent,
    ],
    imports: [
        ManufacturerRoutingModule,
        MaterialsModule,
        FormsModule,
        ImageCropperComponent,
        ReactiveFormsModule,
       // MatPasswordStrengthModule,
        CommonModule,
        BaseChartDirective,
        EllipsisTooltipDirective
    ],
    exports: [
        FactoryProfileComponent
    ]
})
export class ManufacturerModule { }
